/** Mensaje de error inline debajo de un campo de formulario. */
export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <p className="text-xs text-red-400 mt-1" role="alert">
      {message}
    </p>
  );
}
